let sliderTransitionLock = false;

// Fixes chrome issue on color change with slider https://github.com/tannerhodges/snap-slider
function sliderResetCompatabilityFix() {
  sliderTransitionLock = true;
  var allChildren = document.querySelectorAll(".pf-list-media div *");
  var firstVisibleChild = Array.from(allChildren).find(function (element) {
    return element.offsetParent !== null; // Check if the element is visible
  });

  if (firstVisibleChild) {
    // 1) Grab the data-img-id value from firstVisibleChild
    var imgId = firstVisibleChild.getAttribute("data-img-id");

    // 2) Look at the children of the first element that gets selected with the .pf-media-slider class
    var mediaSlider = document.querySelector(".pf-media-slider");

    if (mediaSlider) {
      var children = mediaSlider.children;

      for (const child of Array.from(children)) {
        const mediaId = child.getAttribute("data-media-id");

        if (mediaId === imgId) {
          const hasIsVisible = child.classList.contains("is-visible");

          if (!hasIsVisible) {
            // Resets position to first thumbnail image
            mediaSlider.SnapSlider.goto(1, {
              force: true,
              immmediate: true,
            });

            // Sets a timeout to reset it if it didn't work
            setTimeout(function () {
              firstVisibleChild.setAttribute("data-active", true);
            }, 1000);

            setTimeout(function () {
              if (sliderTransitionLock) {
                sliderResetCompatabilityFix();
              }
            }, 1000);
          } else {
            setTimeout(function () {
              firstVisibleChild.setAttribute("data-active", true);
            }, 100);
          }
          break;
        }
      }
    }
  }
}

// Fixes Patchumz collection A-B-C patches hover image
function patchumzABCHoverFix() {
  document
    .querySelectorAll('[data-media-id="29210482180268"]')
    .forEach((element) => {
      const slider = element ? element.parentElement : null;
      if (!slider) return;
      const slides = slider.querySelectorAll(".pf-slide-main-media");
      const secondImageUrl =
        "//www.happygear.com/cdn/shop/files/Large_Letters_1.webp"; // Replace with the actual URL of secondImage

      if (slides.length < 2) return; // Skip if there are fewer than 2 slides

      const secondImgElement = slides[1].querySelector("img");

      if (!secondImgElement || secondImgElement.src.includes(secondImageUrl)) {
        // Skip if the second image is already the secondImage URL
        return;
      }

      let previousImage = secondImgElement.src;

      for (let i = 2; i < slides.length; i++) {
        console.log("Checking slide " + i);
        const currentImgElement = slides[i].querySelector("img");
        if (!currentImgElement) continue;

        if (!currentImgElement.src.includes(secondImageUrl)) {
          console.log("Swapping images");
          const tempSrc = currentImgElement.src;
          currentImgElement.src = previousImage;
          previousImage = tempSrc;
        } else {
          console.log(
            "Found the second image, swapping and replacing 2nd slide with 2nd image"
          );
          // If the current image is the secondImageUrl, replace it with the previous image and stop
          currentImgElement.src = previousImage;
          slides[1].querySelector("img").src =
            "//www.happygear.com/cdn/shop/files/Large_Letters_1.webp?v=1714560295";
          break;
        }
      }
    });
}

// Handle all images displayed for variants
// Original code below stopped working 5/20/2024 due to what appears to be a Pagefly change
// function handleVariantImages(evt) {
//   var colorRegex = evt.srcElement.id.match(/-Color-(\w+)-/);
//   var letterRegex = evt.srcElement.id.match(/-Letter-(\w+)-/);
//   if (colorRegex != null) {
//     document
//       .querySelectorAll("[thumbnail-alt]")
//       .forEach((img) => (img.style.display = "none"));
//     const thumbnailSelector = `[thumbnail-alt = '${colorRegex[1]}']`;
//     document
//       .querySelectorAll(thumbnailSelector)
//       .forEach((img) => (img.style.display = "block"));
//     document
//       .querySelectorAll(`[thumbnail-alt = 'All']`)
//       .forEach((img) => (img.style.display = "block"));
//   }
//   if (letterRegex != null) {
//     document
//       .querySelectorAll("[thumbnail-alt]")
//       .forEach((img) => (img.style.display = "none"));
//     const thumbnailSelector = `[thumbnail-alt = '${letterRegex[1]}']`;
//     document
//       .querySelectorAll(thumbnailSelector)
//       .forEach((img) => (img.style.display = "block"));
//     document
//       .querySelectorAll(`[thumbnail-alt = 'All']`)
//       .forEach((img) => (img.style.display = "block"));
//   }

//   // Reset variant image to first in carousel
//   setTimeout(function () {
//     sliderResetCompatabilityFix();
//   }, 200);
// }

function handleVariantImages(evt) {
  if ( evt.srcElement.id ) {
    //var colorRegex = evt.srcElement.id.match(/-Color-(\w+)-/);
    var colorRegex = evt.srcElement.id.match(/Color-([A-Za-z-]+)-(\d{4,})/);
    var letterRegex = evt.srcElement.id.match(/-Letter-(\w+)-/);
    
    document.querySelectorAll(".pf-media-slider").forEach((pfMediaSlider) => {
      if (colorRegex != null) {
        const wordToSearch = colorRegex[1].replace(/-/g, ' ');
        pfMediaSlider.querySelectorAll("[alt]").forEach((img) => {
          if (img.parentElement) {
            img.parentElement.style.display = "none"; // Update this line to the desired style
          }
        });
        const thumbnailSelector = `[alt = '${wordToSearch}']`;
        pfMediaSlider.querySelectorAll(thumbnailSelector).forEach((img) => {
          if (img.parentElement) {
            img.parentElement.style.display = "block"; // Update this line to the desired style
          }
        });
        pfMediaSlider.querySelectorAll(`[alt = 'All']`).forEach((img) => {
          if (img.parentElement) {
            img.parentElement.style.display = "block"; // Update this line to the desired style
          }
        });
      }
      if (letterRegex != null) {
        pfMediaSlider.querySelectorAll("[alt]").forEach((img) => {
          if (img.parentElement) {
            img.parentElement.style.display = "none"; // Update this line to the desired style
          }
        });
        const thumbnailSelector = `[alt = '${letterRegex[1]}']`;
        pfMediaSlider.querySelectorAll(thumbnailSelector).forEach((img) => {
          if (img.parentElement) {
            img.parentElement.style.display = "block"; // Update this line to the desired style
          }
        });
        pfMediaSlider.querySelectorAll(`[alt = 'All']`).forEach((img) => {
          if (img.parentElement) {
            img.parentElement.style.display = "block"; // Update this line to the desired style
          }
        });
      }
    });

    // Reset variant image to first in carousel
    setTimeout(function () {
      sliderResetCompatabilityFix();
    }, 200);
  }
}

// Add badge with Standard, Mini or Large Pachumz
function addBadges() {
  if (document.body.id == "shop-all-patchumz") {
    Array.from(document.querySelectorAll(".pf-product-form")).forEach((e) => {
      const regex = /\b(\w+)\s+Patchumz\b/;

      // Extract the word before "Patchumz"
      const match = regex.exec(e.innerText);

      if (
        match != null &&
        match != undefined &&
        match[1] != null &&
        match[1] != undefined
      ) {
        const badge = document.createElement("p");
        badge.innerText = match[1];
        badge.classList.add("pf-badge-patchumz");
        e.appendChild(badge);
      }
    });
  }
}

function handleClick() {
  console.log("handleClick");

  const elements = document.querySelectorAll(".pf-slide-list-media");

  elements.forEach((e) => {
    e.style.cssText;
    if (e.style.cssText == "display: block;") {
      e.click();
    } else {
      console.log("The element does not have display: block style.");
    }
  });
}

function handleClickUnlock() {
  sliderTransitionLock = false;
}

function handleChangeVariant() {
  const variants = document.querySelectorAll("[data-option-name = 'Color']");

  variants.forEach((element) => {
    element.addEventListener("click", handleClick);
  });
}

document.addEventListener("change", function (evt) {
  handleVariantImages(evt);
});

document.addEventListener("load", function (evt) {
  handleVariantImages(evt);
});

document.addEventListener("DOMContentLoaded", function (evt) {
  try {
    addBadges();
  } catch (e) {
    console.log(e);
  }
  try {
    handleChangeVariant();
  } catch (e) {
    console.log(e);
  }
  try {
    createSliderNavigation("#youth-happy-hat-patchumz™");
    createSliderNavigation("#adult-happy-hat-patchumz™");
    createSliderNavigation("#happy-cap-patchumz™");
    createSliderNavigation("#letters");
    createSliderNavigation("#protection-pouch");
    removeSlideNavigationsOnBorders("#youth-happy-hat-patchumz™");
    removeSlideNavigationsOnBorders("#adult-happy-hat-patchumz™");
    removeSlideNavigationsOnBorders("#happy-cap-patchumz™");
    removeSlideNavigationsOnBorders("#letters");
    removeSlideNavigationsOnBorders("#protection-pouch");
  } catch (e) {
    console.log(e);
  }

  try {
    changeQuickViewButtonBehavior();
    handleVariantImages(evt);
  } catch (e) {
    console.log(e);
  }
  try {
    patchumzABCHoverFix();
  } catch (e) {
    console.log(e);
  }

  try {
    let checked = document.querySelector(
      "[data-option-name = 'Color'] input[type='radio']:checked"
    );
    if (!checked){
      checked = document.querySelector(
          "[data-option-name = 'Letter'] input[type='radio']:checked"
      );
    }
    if (!checked) return;
    handleVariantImages({
      srcElement: {
        id: checked.id,
      },
    });
  } catch (e) {
    console.log(e);
  }

    const mediaList  = document.querySelectorAll(".pf-list-media div div");
    mediaList.forEach((media) => {
        media.addEventListener("click", function (event) {
            // Prevent the default behavior of the link
          handleClickUnlock();
        });
    });
});

function changeQuickViewButtonBehavior(quickAddButton) {
  var quickAddButton = document.querySelectorAll(
    `[data-product-id="7849162801324"]`
  )[4];
  if (
    quickAddButton == undefined ||
    quickAddButton.getAttribute("type") != "button"
  )
    return;
  quickAddButton.removeAttribute("data-checkout");
  quickAddButton.removeAttribute("name");
  quickAddButton.removeAttribute("type");
  quickAddButton.removeAttribute("data-pf-type");
  quickAddButton.style.display = "block";

  quickAddButton.addEventListener("click", function (event) {
    // Prevent the default behavior of the link
    event.preventDefault();
  });

  // Create a new anchor element
  var quickAddLink = document.createElement("a");

  // Copy attributes from button to anchor
  Array.from(quickAddButton.attributes).forEach(function (attr) {
    quickAddLink.setAttribute(attr.name, attr.value);
  });

  // Set href attribute for the anchor (assuming '#' for now)
  quickAddLink.setAttribute("href", "/products/premium-letters-patchumz");

  // Set inner text of the anchor
  quickAddLink.innerText = "Select Letter";

  // Replace the button element with the anchor element
  quickAddButton.parentNode.replaceChild(quickAddLink, quickAddButton);
}

// Slider navigation
function createSliderNavigation(pageId) {
  // Get the scrollable div and content
  const content = document.querySelector(`${pageId} .pf-media-slider`);

  if (content == undefined) return;

  // Create the buttons
  const prevButton = document.createElement("a");
  prevButton.setAttribute("type", "button");
  prevButton.classList.add("pf-slider-prev");
  prevButton.classList.add("pf-slider-prev--special");
  prevButton.addEventListener("click", function () {
    // Scroll to the left
    content.scrollLeft -= 500; // Adjust the scroll amount as needed
  });

  const nextButton = document.createElement("a");
  prevButton.setAttribute("type", "button");
  nextButton.classList.add("pf-slider-next");
  nextButton.classList.add("pf-slider-next--special");
  nextButton.addEventListener("click", function () {
    // Scroll to the right
    content.scrollLeft += 500; // Adjust the scroll amount as needed
  });

  // Append the buttons to the container div
  content.appendChild(prevButton);
  content.appendChild(nextButton);
}

// Change
function removeSlideNavigationsOnBorders(pageId) {
  const elements = document.querySelectorAll(`${pageId} .pf-slide-main-media`);

  if (elements == undefined || elements.length == 0) return;

  const prevButton = document.getElementsByClassName(
    "pf-slider-prev--special"
  )[0];
  const nextButton = document.getElementsByClassName(
    "pf-slider-next--special"
  )[0];

  // Create a new MutationObserver
  const observerFirst = new MutationObserver((mutationsList) => {
    // Check each mutation for changes to class list
    mutationsList.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        elements.forEach((e) => {
          var processedElement = Array.from(
            Array.from(elements).find((e) => e.style.display != "none")
              .classList
          );
          if (
            processedElement[1] == "is-visible" ||
            processedElement[1] == "is-current"
          ) {
            prevButton.style.display = "none";
          } else {
            prevButton.style.display = "block";
          }
        });
      }
    });
  });

  const observerLast = new MutationObserver((mutationsList) => {
    // Check each mutation for changes to class list
    mutationsList.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        if (
          elements[elements.length - 1].classList.value.includes("is-visible")
        ) {
          nextButton.style.display = "none";
        } else {
          nextButton.style.display = "block";
        }
      }
    });
  });

  // Define the configuration for the observer (we want to monitor attributes)
  const config = { attributes: true };
  observerFirst.observe(elements[0], config);
  observerLast.observe(elements[elements.length - 1], config);
}// Start observing the target node for configured mutations

window.onload = function() {

  // Define the specific product handle you want to target
  const targetProductHandle = 'mini-letters'; // replace with the handle of the specific product

  // Check if the current URL matches the target product handle

    // Define a target element that only appears after PageFly finishes loading
    const targetSelector = '.pf-option-swatches'; // Replace with a unique selector in your PageFly content

    // Function to execute your custom JavaScript
    function executeAfterPageFlyLoad() {
      const variantBox = document.querySelector('.pf-option-swatches');

      if (window.location.pathname.includes(`/products/${targetProductHandle}`)) {
      const oldElement = variantBox.querySelector('input[type="radio"][value="100"]');

      if (oldElement) {
        // You now have the input element with value "100"
        const parentOldElement = oldElement.closest('div[data-option-name="Letter"].pf-vs-color.pf-vs-square');
        parentOldElement.style.display = 'none';
      }

      const heartElement = variantBox.querySelector('input[type="radio"][value="Heart"]');

      if (heartElement) {
        // You now have the input element with value "100"
        const parentHeartElement = heartElement.closest('div[data-option-name="Letter"].pf-vs-color.pf-vs-square');

        const heartLabelSpan = parentHeartElement.querySelector('label[for="' + heartElement.id + '"] span');

        if (heartLabelSpan) {
          // Replace the text content with the heart symbol
          heartLabelSpan.innerHTML = '&#10084;';
        }
      }

      };

      const parentElement = variantBox.closest('div[data-display="dropdown"][data-product-id][class*="sc-frelQW"][class*="pf-34_"]');
      if ( parentElement ) {
        parentElement.style.display = 'block';
      }
    }

    // Observe the document for PageFly element loading
    const observer = new MutationObserver((mutations, observer) => {
      if (document.querySelector(targetSelector)) {
        executeAfterPageFlyLoad();
        observer.disconnect();
      }
    });

    // Start observing the body for changes
    observer.observe(document.body, { childList: true, subtree: true });
  
};
